// extracted by mini-css-extract-plugin
export default {"thankYouWrapper":"_2AcrS","withBg":"WeeaD","thankYouTextWrapper":"_1zv0A","thankYouTitle":"_7ZRwc","thankYouSubtitle":"_1uGEB","thankYouImg":"RjjU0"};